/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import { interpolate } from "flubber";
import React from "react";
import {
  Animated, Easing, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle
} from "react-native";
import SVG_Svg, {
  G as SVG_G, GProps, Path as SVG_Path, PathProps
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none"> <desc id="IMP.BLUE">{"#CheckMarkBoxAnimated":{"type":"SELECTOR","constraint":"none","width":160,"height":368},"#Property_201_3DDefault":{"type":"SELECTOR","constraint":"xMinYMin meet","width":53.33333206176758,"height":53.33333206176758},"#OpenBox":{"type":"SELECTOR","constraint":"none","width":53.33333206176758,"height":53.33333206176758},"#WhiteSpace":{"type":"SELECTOR","constraint":"none","width":38.66685104370117,"height":33.333457946777344},"#Property_201_3DVariant2":{"type":"SELECTOR","constraint":"xMinYMin meet","width":53.33333206176758,"height":53.33333206176758},"#Property_201_3DVariant3":{"type":"SELECTOR","constraint":"xMinYMin meet","width":53.33333206176758,"height":53.33333206176758},"morph":{"condition":"props.morph","targets":{"Property_1=Default":{"type":"ease","duration":500,"delay":0},"Property_1=Variant2":{"type":"ease","duration":500,"delay":0},"Property_1=Variant3":{"type":"bounceIn","duration":500,"delay":0}},"numStates":3},"#mystate_3Dunchecked":{"type":"SELECTOR","constraint":"xMinYMin meet","width":54,"height":54},"#mystate_3Dmiddle":{"type":"SELECTOR","constraint":"xMinYMin meet","width":53.33333206176758,"height":53.33333206176758},"#mystate_3Dchecked":{"type":"SELECTOR","constraint":"xMinYMin meet","width":54,"height":54},"#mystate_3DmouseDown":{"type":"SELECTOR","constraint":"xMinYMin meet","width":54,"height":54},"transforms":{}}</desc>
 * <g id="mystate=unchecked">
 * <rect id="OpenBox" width="53.3333" height="53.3333" rx="5.33333" fill="black"/>
 * <path id="WhiteSpace" d="M2 48.2778V4.72222C2.08957 3.38204 3.20961 2.04032 4.72222 2H48.2778C50.4556 2 51 3.81482 51 4.72222V48.2778C51 50.4556 49.1852 51 48.2778 51H4.72222C2.54444 51 2 49.1852 2 48.2778Z" fill="white"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
 * <g id="mystate=mouseDown">
 * <rect id="OpenBox" width="53.3333" height="53.3333" rx="5.33333" fill="black"/>
 * <path id="WhiteSpace" d="M26.333 27.2593V26.0741C26.3354 26.0376 26.3659 26.0011 26.4071 26H27.5923C27.6515 26 27.6663 26.0494 27.6663 26.0741V27.2593C27.6663 27.3185 27.617 27.3333 27.5923 27.3333H26.4071C26.3478 27.3333 26.333 27.284 26.333 27.2593Z" fill="white"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 2
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
 * <g id="mystate=checked">
 * <rect id="OpenBox" width="53.3333" height="53.3333" rx="5.33333" fill="black"/>
 * <path id="WhiteSpace" fill-rule="evenodd" clip-rule="evenodd" d="M45.0827 11.3971C46.5202 12.5471 46.7533 14.6448 45.6033 16.0823L24.2699 42.749C23.6497 43.5243 22.7162 43.9827 21.7235 43.9995C20.7308 44.0163 19.7823 43.5898 19.1362 42.836L8.46953 30.3915C7.27146 28.9938 7.43333 26.8894 8.83108 25.6914C10.2288 24.4933 12.3332 24.6552 13.5312 26.0529L21.5785 35.4414L40.3975 11.9177C41.5475 10.4801 43.6452 10.2471 45.0827 11.3971Z" fill="white"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#CheckMarkBoxAnimated": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 160,
 * 		"height": 368
 * 	},
 * 	"#Property_201_3DDefault": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 53.33333206176758,
 * 		"height": 53.33333206176758
 * 	},
 * 	"#OpenBox": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 53.33333206176758,
 * 		"height": 53.33333206176758
 * 	},
 * 	"#WhiteSpace": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 38.66685104370117,
 * 		"height": 33.333457946777344
 * 	},
 * 	"#Property_201_3DVariant2": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 53.33333206176758,
 * 		"height": 53.33333206176758
 * 	},
 * 	"#Property_201_3DVariant3": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 53.33333206176758,
 * 		"height": 53.33333206176758
 * 	},
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"Property_1=Default": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"Property_1=Variant2": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"Property_1=Variant3": {
 * 				"type": "bounceIn",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 3
 * 	},
 * 	"#mystate_3Dunchecked": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 54,
 * 		"height": 54
 * 	},
 * 	"#mystate_3Dmiddle": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 53.33333206176758,
 * 		"height": 53.33333206176758
 * 	},
 * 	"#mystate_3Dchecked": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 54,
 * 		"height": 54
 * 	},
 * 	"#mystate_3DmouseDown": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 54,
 * 		"height": 54
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  mystate?: "unchecked" | "mouseDown" | "checked";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigWhiteSpaced: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const CheckMarkBoxAnimated = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  mystate?: "unchecked" | "mouseDown" | "checked";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 54,
      height: 54,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigWhiteSpaced:
        "M2 48.2778V4.72222C2.08957 3.38204 3.20961 2.04032 4.72222 2H48.2778C50.4556 2 51 3.81482 51 4.72222V48.2778C51 50.4556 49.1852 51 48.2778 51H4.72222C2.54444 51 2 49.1852 2 48.2778Z",
    },
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    mystate: "unchecked" | "mouseDown" | "checked";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      mystate: "unchecked",
    },
    1: {
      mystate: "mouseDown",
    },
    2: {
      mystate: "checked",
    },
  };

  function getNextMorphState(): number {
    const { mystate, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].mystate === mystate) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 2;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Morph",
        morphId: "morphConfigWhiteSpaced",
        paths: [
          "M2 48.2778V4.72222C2.08957 3.38204 3.20961 2.04032 4.72222 2H48.2778C50.4556 2 51 3.81482 51 4.72222V48.2778C51 50.4556 49.1852 51 48.2778 51H4.72222C2.54444 51 2 49.1852 2 48.2778Z",
          "M26.333 27.2593V26.0741C26.3354 26.0376 26.3659 26.0011 26.4071 26H27.5923C27.6515 26 27.6663 26.0494 27.6663 26.0741V27.2593C27.6663 27.3185 27.617 27.3333 27.5923 27.3333H26.4071C26.3478 27.3333 26.333 27.284 26.333 27.2593Z",
          "M45.0827 11.3971C46.5202 12.5471 46.7533 14.6448 45.6033 16.0823L24.2699 42.749C23.6497 43.5243 22.7162 43.9827 21.7235 43.9995C20.7308 44.0163 19.7823 43.5898 19.1362 42.836L8.46953 30.3915C7.27146 28.9938 7.43333 26.8894 8.83108 25.6914C10.2288 24.4933 12.3332 24.6552 13.5312 26.0529L21.5785 35.4414L40.3975 11.9177C41.5475 10.4801 43.6452 10.2471 45.0827 11.3971Z",
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);
  // const morphValues: {
  //   [id: string]: string[] | number[];
  // } = {};

  // function clamp(lower: number, upper: number, v: number) {
  //   let r = v;

  //   if (r > upper) {
  //     r = upper;
  //   } else if (r < lower) {
  //     r = lower;
  //   }

  //   return r;
  // }

  // type tInterpolationRange = {
  //   inputRange: number[];
  //   outputRange: string[] | number[];
  // };

  // function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
  //   const initial = clamp(0, 3, start);
  //   const final = clamp(0, 3, end);
  //   const inputRange = [start, end];
  //   const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
  //     | string[]
  //     | number[];

  //   if (start > end) {
  //     inputRange.reverse();
  //     outputRange.reverse();
  //   }

  //   return {
  //     inputRange,
  //     outputRange,
  //   };
  // }

  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.in(Easing.bounce),
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 54 54"
        >
          <G id="mystate_3Dunchecked">
            <Svg preserveAspectRatio="none" viewBox="0 0 54 54">
              <Path
                id="OpenBox"
                fill="black"
                d="M5.33333 0 H47.999970000000005 a5.33333,5.33333 0 0 1 5.33333,5.33333 V47.999970000000005 a5.33333,5.33333 0 0 1 -5.33333,5.33333 H5.33333 a5.33333,5.33333 0 0 1 -5.33333,-5.33333 V5.33333 a5.33333,5.33333 0 0 1 5.33333,-5.33333z"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="none" viewBox="0 0 54 54">
              <Path
                id="WhiteSpace"
                d="M2 48.2778V4.72222C2.08957 3.38204 3.20961 2.04032 4.72222 2H48.2778C50.4556 2 51 3.81482 51 4.72222V48.2778C51 50.4556 49.1852 51 48.2778 51H4.72222C2.54444 51 2 49.1852 2 48.2778Z"
                fill="white"
                ref={morphProps.bindInterpolation}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 54 54"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="OpenBox"
          fill="black"
          d="M5.33333 0 H47.999970000000005 a5.33333,5.33333 0 0 1 5.33333,5.33333 V47.999970000000005 a5.33333,5.33333 0 0 1 -5.33333,5.33333 H5.33333 a5.33333,5.33333 0 0 1 -5.33333,-5.33333 V5.33333 a5.33333,5.33333 0 0 1 5.33333,-5.33333z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 54 54"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="WhiteSpace"
          d="M2 48.2778V4.72222C2.08957 3.38204 3.20961 2.04032 4.72222 2H48.2778C50.4556 2 51 3.81482 51 4.72222V48.2778C51 50.4556 49.1852 51 48.2778 51H4.72222C2.54444 51 2 49.1852 2 48.2778Z"
          fill="white"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(CheckMarkBoxAnimated);
